import React, { useEffect, useRef } from 'react'
import { Button, Header } from '../../components'
import { GiCancel } from 'react-icons/gi'
import { FaPrint } from 'react-icons/fa'
import Icon from '../../data/icon.png'
import ReactToPrint from 'react-to-print'
import { MdReceiptLong } from 'react-icons/md'
import Barcode from 'react-barcode'
import Entete from '../../components/Entete'
import TabHead from '../../components/TabHead'
import NumberFormat from '../../components/NumberFormat'
import Bfi from './chequeTypes/Bfi'
import Bci from './chequeTypes/Bci'
import Bnm from './chequeTypes/Bnm'
import Bmi from './chequeTypes/Bmi'
import Bpm from './chequeTypes/Bpm'
import Bea from './chequeTypes/Bea'
import Chb from './chequeTypes/Chb'
const PrintChequesList = ({ cheques, onClose }) => {
    const componentRef = useRef();

    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col max-h-screen overflow-auto w-auto bg-white lg:p-10 xl:p-10  p-2 md:p-10  rounded-xl'>
                        <div className=''>
                            <Header icon={<MdReceiptLong />} title="Cheque impression" titleAr={"إيصال الدفع"} />
                        </div>
                        <div className='flex  justify-end items-end'>
                            <div className=' flex gap-3 m-2  justify-between'>
                                <ReactToPrint
                                    trigger={() => {
                                        return <Button icon={<FaPrint />} color="ml-1 bg-green-500" textColor="text-white" text="Imprimer" />
                                    }}
                                    content={() => componentRef.current}
                                    documentTitle='Cheque'
                                    pageStyle={`
                                        @page {
                                            size: A4; /* Format paysage */
                                            margin: 0;
                                        }
                                    
                                        body {
                                            margin: 0;
                                            padding: 0;
                                            width: 100%;
                                            height: 100%;
                                            -webkit-print-color-adjust: exact;
                                            print-color-adjust: exact;
                                            
                                        }
                                        .ligne{
                                            width: 210mm !important; /* Taille du contenu */
                                            height: 297mm !important; /* Taille du contenu */
                                            display: flex;
                                            justify-content: center; /* Centre horizontalement */
                                            align-items: flex-start; /* Aligne en haut */
                                        }
                                    
                                        .cheque-print {
                                            margin: 0;
                                            padding: 0;
                                            width: 165mm; /* Taille du contenu */
                                            height: 75mm; /* Taille du contenu */
                                            transform: rotate(90deg) translateX(47mm); /* Rotation + décalage vertical */
                                            background-image: url(/bfi.png);
                                            background-size: cover;
                                            background-repeat: no-repeat;
                                            background-position: center top; /* Positionnement de l'image */
                                        }

                                        /* Masquer l'image de fond à l'impression */
                                        @media print {
                                            .cheque-print {
                                            background-image: none !important;
                                            }
                                        }
                                    
                                        button, .no-print {
                                            display: none !important;
                                        }
                                    `}
                                />
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                            </div>
                        </div>
                        <div ref={componentRef}>
                            <table>
                                {cheques && cheques.map(cheque=>(
                                    cheque.banque==='BCI' ?
                                    <Bci cheque={cheque}/>
                                    :
                                    cheque.banque==='BNM' ?
                                    <Bnm cheque={cheque}/>
                                    :
                                    cheque.banque==='BMI' ?
                                    <Bmi cheque={cheque}/>
                                    :
                                    cheque.banque==='BPM' ?
                                    <Bpm cheque={cheque}/>
                                    :
                                    cheque.banque==='BEA' ?
                                    <Bea cheque={cheque}/>
                                    :
                                    cheque.banque==='CHING.BANQUE' ?
                                    <Chb cheque={cheque}/>
                                    :
                                    <Bfi cheque={cheque}/>

                                ))  
                                } 
                            </table>
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default PrintChequesList